import { createBrowserRouter, Navigate, useRouteError } from "react-router-dom";
import Root from "./screens/Root";
import Main from "./screens/home";
import Service from "./screens/service";
import Detail from "./screens/detail";

import Test from "./screens/test";

import NetworkErrorPage from "./components/NetworkErrorPage";
import NotFound from "./components/404";

function ErrorBoundary() {
  const error: any = useRouteError();
  console.log(error);
  switch (error.status) {
    case 404:
      return <NotFound />;
    default:
      return <NetworkErrorPage />;
  }
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: "", element: <Main /> },
      { path: "main", element: <Navigate to="/" replace /> },
      { path: "home", element: <Navigate to="/" replace /> },
      { path: "service", element: <Service /> },
      { path: "test", element: <Test /> },
      { path: ":menu", element: <Detail /> },
    ],
  },
  {
    path: "/networkerror",
    element: <NetworkErrorPage />,
  },
  
]);
export default router;
